// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"76ae4ef9","814":"66a2c3a6"}[chunkId] + ".chunk.js";
};